import styled from 'styled-components';
import { useUuidBasedProject } from 'utils/hooks/useUuidBasedProject';
import { TipPlacement, Tooltip } from 'ui/tooltip';
import { Link } from 'ui/links';
import { useTranslation } from '../../../hooks';
import { User } from '../../../types';
import { USER_PROFILE_LINK_PREFIX } from '../../../constants';
import { usePermissionsContext } from '../../../contexts/permissions';

const DisabledLink = styled.div`
  cursor: not-allowed;
`;

const UserLink = ({ href, children }: { href: string; children: React.ReactNode }) => {
  const { t } = useTranslation();
  const { canViewAndExpUserData } = usePermissionsContext();
  return (
    <Tooltip
      isEnabled={!canViewAndExpUserData}
      placement={TipPlacement.Right}
      tooltipContent={t('permissions.viewAndExportUserData')}
    >
      {canViewAndExpUserData ? (
        <Link href={href} target="_blank">
          {children}
        </Link>
      ) : (
        <DisabledLink>{children}</DisabledLink>
      )}
    </Tooltip>
  );
};

export const UserProfileCell = ({ column, row }: { column: string; row: User }) => {
  const { isUuidProject, isEmailNonUnique } = useUuidBasedProject();

  if (isUuidProject && column === 'userId') {
    return (
      <UserLink href={`${USER_PROFILE_LINK_PREFIX}${row.itblUserId as string}`}>
        {row.userId}
      </UserLink>
    );
  }

  if (column === 'email') {
    const emailLink = isUuidProject ? (row.itblUserId as string) : encodeURIComponent(row.email);

    if (isUuidProject && isEmailNonUnique) {
      return <>{row.email}</>;
    } else {
      return <UserLink href={`${USER_PROFILE_LINK_PREFIX}${emailLink}`}>{row.email}</UserLink>;
    }
  } else {
    return <>{row.userId}</>;
  }
};
